import { types } from './types';

const initialState = {
    list: {
        data: [],
        currentPage: 0,
        currentRowsPerpage: 0,
        total: 0,
        totalPage: 0
    },
    view: {}
}

export function exchangeRatesReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_EXCHANGE_RATES:
            return { ...state, list: action.payload };
        default:
            return state
    }
}